import { render } from "./CustomAlert.vue?vue&type=template&id=deebdf22&scoped=true"
import script from "./CustomAlert.vue?vue&type=script&lang=js"
export * from "./CustomAlert.vue?vue&type=script&lang=js"

import "./CustomAlert.vue?vue&type=style&index=0&id=deebdf22&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-deebdf22"]])

export default __exports__